class Announcements {

	constructor(CegoXMPP) {
		const that = this;
		this.CegoXMPP = CegoXMPP;
		
		jQuery(this.CegoXMPP.chatContainer).on('click', '.prizeShareButton', function() {
			let userTicketId = jQuery(this).attr('id');
			that.CegoXMPP.Announcements.handleSharedPrize(userTicketId);
		});
	}

	parser(msg, callback) {
		const that = this;
		let obj = {};
		let html;

		/* If message contains tags */
		let HTMLMsg = msg.match(/<.*>/);
		if (HTMLMsg !== null && msg.indexOf('spilnu') === -1) {

			html = jQuery('<div>').html(msg);
			this.CegoXMPP.Chat.insertIntoChat(html);

		/* Bank */
		} else if (msg.indexOf('/bank') === 0) {

			msg = msg.replace('/bank ', '');
			/* Split by underscore */
			let result = msg.split('_');
			let username = result[1].split(' ')[0];
			let res = {
				'username': username,
				'message': result[1],
				'bankId': result[2],
				'last4': result[3]
			};
			res.message = res.message.replace(res.username + ' ', '');

			let bankValue = res.message.match(/\d+/);
 			let userTicketId = res.bankId  + '_' + res.last4  + '_' + this.CegoXMPP.user.userId;
			let text = this.CegoXMPP.language.getSharedPrize.replace('5%', Math.floor(bankValue[0] * 0.05));

			this.CegoXMPP.Users.getUserObject(res.username, function(user) {
				
				let o = {
					'img': user.profileImage,
					'title': user.username,
					'text': res.message,
					'link': text
				};
				html = this.standardAnnouncement(o);
				jQuery('.image', html).addClass('round');
				jQuery('.link', html).addClass('prizeShareButton').attr('id', userTicketId).attr('data-username', user.username);

				this.CegoXMPP.Chat.insertIntoChat(html);
			}.bind(this));

		} else if (msg.indexOf('infoTextRank') === 0) {

			if (this.CegoXMPP.UserSettings.get('showRankMessages') === true) {
				msg = msg.replace('infoTextRank ', '');
				let result = msg.match(/(\S*) (.*)/);
				let res = {
					'username': result[1],
					'message': result[2]
				};

				this.CegoXMPP.Users.getUserObject(res.username, function(user) {
					
					let o = {
						'img': user.profileImage,
						'title': user.username,
						'text': res.message,
						'link': this.CegoXMPP.language.congratulate
					};
					html = this.standardAnnouncement(o);
					jQuery('.link', html).on('click', function() {
						that.CegoXMPP.Chat.inputField.setText(that.CegoXMPP.language.congratulations + ' ' + that.CegoXMPP.Chat.capitalize(res.username));
					}).hide();
					jQuery('.image', html).addClass('round');

					this.CegoXMPP.Chat.insertIntoChat(html);
				}.bind(this));

			}

		/* SpilNu Jackpots */
		} else if (msg.indexOf('spilnu') === 0) {
			// spilnu {Las Vegas:} bessman vandt 160,00 kr. (800 + 1200 + 1200 kredit) i 5 jackpotspil.
			let msg = msg.replace(/<b[^>]*>/, '');
			msg = msg.replace(/<\/b>/, '');
			let amount = msg.match(/ ([\d\.]+[\d,\d]+) /);

			if (amount > 0) {
				let amTmp = amount[1].match(/[\d\.]+[\d]+/);
				let amountInt = parseInt(amTmp[0].replace('.', ''), 10);
				let bigPrize = (amountInt > 1000) ? true : false;
			}

			let extraClass = (bigPrize === true) ? 'bigPrize' : '';
			let result = msg.match(/(\{(.*):\}) (\S*) (.*)/);
			let username = result[3];
			let machine = result[2];
			let machineImg = result[2].toLowerCase().replace(' ', '');
			
			if (this.CegoXMPP.UserSettings.get('onlyShowBigJackpots') === true && bigPrize !== true) {

			} else {
				let o = {
					'img': '/images/gameicons24/' + machineImg + '_42x42.png',
					'title': machine,
					'text': this.CegoXMPP.Chat.capitalize(username) + ' ' + result[4]
				};
				html = this.standardAnnouncement(o);

				this.CegoXMPP.Chat.insertIntoChat(html);
			}
		}

		if (typeof callback === 'function') {
			callback();
		}
	}
	
	standardAnnouncement(obj) {
		let inner = jQuery(this.CegoXMPP.chatTemplates + ' .standardAnnouncement').clone();
		jQuery('.image', inner).css('background-image', 'url(' + obj.img + ')');
		jQuery('.title', inner).text(obj.title);
		jQuery('.text', inner).text(obj.text);
		if (obj.link !== undefined) {
			jQuery('.link', inner).text(obj.link);
		}

		return inner;
	}
	
	smallJackpotAnnouncement(obj) {
		let inner = jQuery(this.CegoXMPP.chatTemplates + ' .smallJackpotAnnouncement').clone();
		jQuery('.machine', inner).text(obj.machine + ': ');
		jQuery('.username', inner).text(obj.username).addClass(obj.genderClass);
		jQuery('.text', inner).html(obj.text);
		
		return inner;
	}
	
	bigJackpotAnnouncement(obj) {
		let inner = jQuery(this.CegoXMPP.chatTemplates + ' .bigJackpotAnnouncement').clone();
		jQuery('.image', inner).css('background-image', 'url(' + obj.img + ')');
		jQuery('.title', inner).text(obj.title);
		jQuery('.username', inner).text(obj.username).addClass(obj.genderClass);
		jQuery('.text', inner).html(obj.text);

		return inner;
	}

	handleSharedPrize(userTicketId) {
		const that = this;
		$.get('/ajax/chat_ajax_misc.php', {
			what: 'processPrizeshare',
			ticket : userTicketId
		}, function (callbackData) {

			/* CallbackData is:
			int noOfWonTokens if success
			-3 if fail repeated attempt
			-2 if invalid string
			-1 if timed out
			*/
		
			/* Stop further clicks if callback data is valid */
			// if (callbackData >= -3) {
				
				/* Remove button */
				jQuery('.prizeShareButton[id=' + userTicketId + ']')
				.removeAttr('id')
				.removeClass('prizeShareButton')
				.text(this.CegoXMPP.language.congratulate)
				.on('click', function() {
					that.CegoXMPP.Chat.inputField.setText(that.CegoXMPP.language.congratulationsAndThankYou + ' ' + that.CegoXMPP.Chat.capitalize(jQuery(this).attr('data-username')));
					// that.CegoXMPP.Chat.sendAction(this.CegoXMPP.Chat.inputField.getInput());
					jQuery(this).remove();
				});
				this.CegoXMPP.Chat.addInfoMessage(this.CegoXMPP.Chat.CURRENT_PUBLIC_ROOM, this.CegoXMPP.language.prizePaid);
			// } else {
				// jQuery('.prizeShareButton[id=' + userTicketId + ']').remove();
			// }
		}.bind(this));
	}
}